import { LocalizationContainer } from '@/features/localization';

export default function LocalizationPage() {
  return (
    <section className="localization-page">
      <header className="localization-page__header">
        <h1>Localización de modelos</h1>
        <p>
        Genera, revisa y aplica localizaciones controladas por SKU.
        </p>
      </header>
      <LocalizationContainer />
    </section>
  );
}
